import {
  getWorkingTreeChangeRepoDetails,
  type WorkingTreeChangeRepoDetail,
  type WorkingTreeRepoChangesBasis,
} from '../../../git/changes/index.js';
import { normalizeRepoPathRelativeToWorkspaceRoot } from '../../../git/changes/repo/normalize-repo-path-relative-to-workspace-root.js';
import type { SessionWorktreeCache } from '../session-worktree-cache.js';
import { resolveCommitTargetsAsync } from '../resolve-commit-targets.js';
import type { SessionDiscover } from './types.js';

export async function getSessionWorkingTreeChangeDetails(
  cache: SessionWorktreeCache,
  sessionId: string,
  discover: SessionDiscover,
  opts?: { repoRelPath?: string; basis?: WorkingTreeRepoChangesBasis; recentCommitsLimit?: unknown },
): Promise<WorkingTreeChangeRepoDetail[]> {
  const targets = await resolveCommitTargetsAsync(sessionId, cache, discover);

  return getWorkingTreeChangeRepoDetails({
    commitTargetPaths: targets,
    sessionParentPath: cache.getSessionParentPath(sessionId) ?? null,
    repoFilterRelPath: opts?.repoRelPath?.trim()
      ? normalizeRepoPathRelativeToWorkspaceRoot(opts.repoRelPath.trim())
      : null,
    basis: opts?.basis,
    recentCommitsLimit: opts?.recentCommitsLimit,
    includeFilePatches: false,
  });
}
